import {combineReducers} from 'redux'
import appMiddlewareList from 'middlewares'
import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'

// Reducers
import {reducer as book} from 'modules/book'
import {reducer as localization} from 'modules/localization'
import {reducer as overlay} from 'modules/overlay'
import {reducer as common} from 'modules/common'
import {reducer as raaOffers} from 'modules/raaOffers'
import {reducer as paymentOptions} from 'modules/paymentOptions'
import psd2Auth from 'modules/psd2Auth/slice'
import offerCheck from 'modules/offerCheck/slice'
import meta, {augmentMetaState} from 'modules/meta'

import device from '@daedalus/core/src/user/modules/device/slice'
import experiments from '@daedalus/core/src/experiments/modules/slice'
import authentication from '@daedalus/core/src/auth/modules/slice'
import accessControl from '@daedalus/core/src/accessControl/modules/slice'
import authMiddlewares from '@daedalus/core/src/auth/modules/middleware'
import rooms from 'modules/rooms/slice'
import hotelApi from 'modules/hotelApi/slice'
import {bookApi} from '@daedalus/core/src/booking/services/bookApi'

let store

const middlewareList = [...appMiddlewareList, ...authMiddlewares]

const bookApiReducer = {[bookApi.reducerPath]: bookApi.reducer}
const createReducer = () =>
  combineReducers({
    meta,
    book,
    localization,
    overlay,
    common,
    rooms,
    raaOffers,
    device,
    authentication,
    psd2Auth,
    experiments,
    offerCheck,
    accessControl,
    paymentOptions,
    hotelApi,
    ...bookApiReducer
  })

export const initializeStore = (initialState?: any) => {
  // eslint-disable-next-line fp/no-mutation
  store = configureStore({
    reducer: createReducer(),
    preloadedState: {
      ...initialState,
      meta: augmentMetaState(initialState)
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        immutableCheck: false
      }).concat(...middlewareList)
  })

  return store
}

if (store) {
  setupListeners(store.dispatch)
}

type CreateReducer = ReturnType<typeof createReducer>
export type RootState = ReturnType<CreateReducer>

export default initializeStore
